export default __webpack_public_path__ + "static/media/placeholder_portfolio02-jp-mobile.c3ce6809.png";